import { render, staticRenderFns } from "./settingsGroupIcon.vue?vue&type=template&id=6a4aecd3&scoped=true"
import script from "./settingsGroupIcon.vue?vue&type=script&lang=js"
export * from "./settingsGroupIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4aecd3",
  null
  
)

export default component.exports